import { OperatorPanelWrapper } from '../../components/Layout'
import { IAnalogSetpoint } from './types'
import { FormControl } from 'baseui/form-control';
import ValueInput from './ValueInput';

export const OperatorPanel = (props: IAnalogSetpoint) => {

  const limitText = (hasValue(props.limitMin) ? `min: ${props.limitMin}` : '') + ' ' + (hasValue(props.limitMax) ? `max: ${props.limitMax}` : '')
  return (

    <OperatorPanelWrapper
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={
        <FormControl
          label={() => props.description}
          caption={() => limitText}
        >
          <ValueInput {...props} />
        </FormControl>
      }
    >
    </OperatorPanelWrapper>
  )
}

const hasValue = (value: any) => {
  if (value === undefined)
    return false;
  if (value === null)
    return false;

  return true;
}
